import noop from 'lodash/noop';
import type { FunctionComponent, PropsWithChildren } from 'react';
import { createContext, useContext } from 'react';

export type RequestCommentsOpen = () => void;

const CommentsOpenRequestContext = createContext<RequestCommentsOpen>(noop);

// Lets a row deep inside a member tile reveal the group comment tile without knowing that the
// tile is a URL tile: the hosting tile supplies the payload write.
export const CommentsOpenRequestProvider: FunctionComponent<
    PropsWithChildren<{ readonly requestCommentsOpen: RequestCommentsOpen }>
> = ({ children, requestCommentsOpen }) => (
    <CommentsOpenRequestContext.Provider value={requestCommentsOpen}>{children}</CommentsOpenRequestContext.Provider>
);

export const useRequestCommentsOpen = (): RequestCommentsOpen => useContext(CommentsOpenRequestContext);
